import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, EnviaInteracoesAtendimento } from './types';

export const INITIAL_STATE: EnviaInteracoesAtendimento = {
	status: 0,
	data: null,
	form: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EnviaInteracoesAtendimento {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIA_INTERACOES_ATENDIMENTO_REQUEST: {
				draft.form = action.payload;
				break;
			}
			case Types.ENVIA_INTERACOES_ATENDIMENTO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ENVIA_INTERACOES_ATENDIMENTO_FAILURE: {
				draft.status = 0;
				draft.data = action.payload;
				break;
			}
			case Types.ENVIA_INTERACOES_ATENDIMENTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.form = INITIAL_STATE.form;
				break;
			}

			default:
		}
		return draft;
	});
}
